// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k8ys","field":"styles_field__3Xmd1","fieldCol":"styles_fieldCol__n63NI","diffCol":"styles_diffCol__3cSOJ","diff":"styles_diff__20wP2"};